import React, { useEffect, useState, Fragment } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";

import CardContent from "@mui/material/CardContent";
import Container from "@mui/material/Container";

import TableEmployee from "./tableEmployee";


import { getPayrunsSummaryYearDetail } from "../../../../../actions/payruns";


//Translator TH-EN
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

const StyledRoot = styled("div")({
  backgroundColor: "#FFFFFF !important",
  paddingBottom: 24,
});

const StyledCardContent = styled(CardContent)({
  height: "100%",
  padding: 24,
  // display: "flex",
  // justifyContent: "center",
  // alignItems: "center",
  "& .wrap-header-filter": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
    "& .wrap-filter": {
      display: "flex",
      "& .btn-filter": {
        marginRight: 8,
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 8,
      },
    },
  },
  "& .wrap-manage": {
    marginBottom: 24,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& .wrap-manage-group": {
      display: "flex",
      alignItems: "center",
      "& .btn-mamage-group-company": {
        marginRight: 8,
      },
    },
    "& .wrap-edit-selected": {},
  },
  "& .wrap-panel": {
    height: 490,
    overflow: "auto",
    display: "flex",
  },
});

const StyledLoading = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "inherit",
});

const PayRunsEditPage = (props) => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  let { year, idEmployee } = useParams();
  let history = useHistory();
  const { result: userProfile } = useSelector((state) => state.userProfile);
  const { result: payRunDetail } = useSelector((state) => state.payRunDetail);
  // const { result: payRunList } = useSelector((state) => state.payRun);
  const { result: payRunSummaryYearDetail } = useSelector(
    (state) => state.payRunSummaryYearDetail
  );
  const [openAlert, setOpenAlert] = useState(false);
  const [alertType, setAlertType] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selected, setSelected] = useState(false);

  useEffect(() => {
    dispatch(getPayrunsSummaryYearDetail(year, idEmployee));
  }, []);

  const handleChangeAlertType = (newValue) => {
    setAlertType(newValue);
  };

  const handleOpenAlert = () => {
    setOpenAlert(true);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleOpenDialogDelete = (selected) => {
    setSelected(selected);
    setOpenDelete(true);
  };

  const handleCloseDialog = () => {
    setOpenDelete(false);
  };

  return (
    <StyledRoot className={`page`}>
      <Container maxWidth="lg">
        <Fragment>
          {payRunSummaryYearDetail ? (
            <TableEmployee handleOpenDialogDelete={handleOpenDialogDelete} />
          ) : (
            <StyledLoading>
              {/* <img width="120" alt="loading" src={loading} /> */}
            </StyledLoading>
          )}

          {/* <DialogGroup
          manageBy={manageBy}
          open={open}
          handleClose={handleCloseDialogGroup}
        /> */}
        </Fragment>
      </Container>
    </StyledRoot>
  );
};

export default PayRunsEditPage;
